module.exports = __webpack_public_path__ + "static/media/SVGyourstory.fe2f5d5f.webp";